<div class="result-dialog">
    <!-- Calculating state -->
    <div *ngIf="calculating" class="calculating-state">
        <div class="loading">
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
            <div class="loading-bar"></div>
        </div>
        <p class="calculating-text mat-body-large">Processing...</p>
    </div>

    <!-- Result state -->
    <div *ngIf="!calculating" class="result-state">
        <div class="result-header">
            <h1 class="mat-title-large">Your result</h1>
            <button mat-icon-button type="button" class="close-btn" (click)="close()" aria-label="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <!-- Likely approved (score 7–9) -->
        <div class="result-band result-likely" *ngIf="outcome === 'likely'">
            <div class="result-content">
                <h2 class="mat-title-large"><strong>Good news — you look eligible for finance with Avanti</strong></h2>
                <p class="mat-body-large">
                    Based on what you've told us, your profile matches what Avanti Finance typically looks for. This
                    isn't a final decision - a full application will confirm your eligibility and finance offer.
                </p>
                <div class="button-row">
                    <button mat-flat-button type="button" class="green-btn" (click)="applyNow()">Apply now</button>
                </div>
            </div>
        </div>

        <!-- Hard to say (score 4–6) -->
        <div class="result-band result-hard" *ngIf="outcome === 'hard-to-say'">
            <div class="result-content">
                <h2 class="mat-title-large"><strong>Let's get to know you a bit more</strong></h2>
                <p class="mat-body-large">
                    Based on your answers, there are some real positives for an Avanti Finance application - but a few
                    things they'd want to understand better before giving a clear answer. You can submit a full
                    application now to get the ball rolling or touch base with our team to talk through options.
                </p>
                <div class="button-row">
                    <button mat-flat-button type="button" class="dark-btn" (click)="applyNow()">Full
                        application</button>
                    <button mat-stroked-button type="button" class="outline-btn" (click)="getInTouch()">Get in
                        touch</button>
                </div>
            </div>
        </div>

        <!-- Unlikely (score 0–3) -->
        <div class="result-band result-unlikely" *ngIf="outcome === 'unlikely'">
            <div class="result-content">
                <h2 class="mat-title-large"><strong>Avanti Finance may not be the right fit right now</strong></h2>
                <p class="mat-body-large">
                    Based on what you've told us, Avanti Finance may find it difficult to help with this application.
                    That doesn't rule out other finance options though - get in touch with our team, and we'll see what
                    else might work.
                </p>
                <div class="button-row">
                    <button mat-flat-button type="button" class="dark-btn" (click)="getInTouch()">Get in touch</button>
                    <button mat-stroked-button type="button" class="outline-btn" (click)="applyNow()">Full
                        application</button>
                </div>
            </div>
        </div>

        <!-- Declared credit issues -->
        <div class="result-band result-unlikely" *ngIf="outcome === 'credit-issues'">
            <div class="result-content">
                <h2 class="mat-title-large"><strong>Avanti Finance may not be the right fit right now</strong></h2>
                <p class="mat-body-large">
                    Based on what you've told us, Avanti Finance may find it difficult to help with this application.
                    That doesn't rule out other finance options though - get in touch with our team, and we'll see what
                    else might work.
                </p>
                <div class="button-row">
                    <button mat-flat-button type="button" class="dark-btn" (click)="getInTouch()">Get in touch</button>
                    <button mat-stroked-button type="button" class="outline-btn" (click)="applyNow()">Full
                        application</button>
                </div>
            </div>
        </div>
    </div>
</div>